(function(){
    var btn = document.getElementById('loadmore');

    if(btn) loadMore();

    function loadMore(){
        var btn_text = btn.textContent;

        btn.addEventListener('click', function(){
            btn.disabled = true;
            btn.textContent = 'Загрузка...';
            var request = new XMLHttpRequest();
            request.open('POST', ajaxurl+'?action=loadmore&query='+true_posts+'&page='+current_page, true);
            request.send();
            request.onload = function() {
                if (request.status >= 200 && request.status < 400) {
                    var resp = request.responseText;
                    if( resp && resp !== '0') {
                        var div = document.createElement("div");
                        div.innerHTML = resp;
                        while ( div.firstChild ) {
                            var item = div.removeChild( div.firstChild );
                            btn.parentNode.parentNode.insertBefore(item, btn.parentNode);
                        }
                        if (current_page == (max_pages) )  btn.parentNode.style.display = 'none';// если последняя страница, скрываем кнопку
                        current_page++; // увеличиваем номер страницы на единицу
                        btn.textContent = btn_text;
                        btn.disabled = false;
                    } else {
                        btn.parentNode.style.display = 'none';
                        console.log('No response...');
                    }

                } else {
                    // We reached our target server, but it returned an error
                    console.log('Ошибка...');
                }
            };
            request.onerror = function() {
                // There was a connection error of some sort
                console.log('Connection Error...');
            };
            return false;
        });
    }
})();
